import { EProductCardForm } from '@/domain/product/EProductCardForm';
import { EProductCategory } from '@/domain/product/EProductCategory';

// Pure derivation: a Card with a cutting path is a cut-shape, a Card
// without is a folded double-panel, anything else has no card form.
// initStore normalises productCuttingPathUuid to null for non-Card
// products so this function stays total.
function deriveCardForm(category: EProductCategory | null, cuttingPathUuid: string | null): EProductCardForm | null {
    if (category !== EProductCategory.Card) {
        return null;
    }
    return cuttingPathUuid ? EProductCardForm.CutShape : EProductCardForm.Folded;
}

export { deriveCardForm };
